import { Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { useDocumentDetails } from "~/Modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { post, put } from "~/Services";
import { decodeHTML } from "~/Utils/CommonUtils";
import { fields } from "./constants";
import {
  useAntiBriberyCorruption,
  useManagementIntegrity,
  useReportingConcern,
  useWhistleblowing,
  useWhistleblowingPolicyData,
} from "./CorporateIntegrity.hook";
import { corporateHost } from "~/Utils";
import { ManagementIntegrityMessage } from "./ManagementIntegrityMessage/ManagementIntegrityMessage";
import { AntiBriberyAndCorruptionPolicyStatement } from "./AntiBriberyAndCorruptionPolicyStatement/AntiBriberyAndCorruptionPolicyStatement";
import { WhistleBlowingProgram } from "./WhistleBlowingProgram/WhistleBlowingProgram";
import { WhistleBlowingPolicy } from "./WhistleBlowingPolicy/WhistleBlowingPolicy";
import { ReportingConcern } from "./ReportingConcern/ReportingConcern";

export const CorporateIntegrity = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();
  useEffect(() => {
    if(query.get("id")){
      return;
    }
    if (!query.get("activeTab")) {
        navigate(`/dedicated/corporate/corporate-integrity?activeTab=managementIntegrityMessage&subActiveTab=managementIntegrityMessagePageHeading`, {
          replace: true,
        });
    }
    if(query.get('activeTab')==='managementIntegrityMessage'){
      navigate(`/dedicated/corporate/corporate-integrity?activeTab=managementIntegrityMessage&subActiveTab=${query.get('subActiveTab')||'managementIntegrityMessagePageHeading'}`, {
        replace: true,
      });
    }
    if(query.get('activeTab')==='antiBriberyCorruption'){
      navigate(`/dedicated/corporate/corporate-integrity?activeTab=antiBriberyCorruption&subActiveTab=${query.get('subActiveTab')||'antiBriberyCorruptionPageHeading'}`, {
        replace: true,
      });
    }
    if(query.get('activeTab')==='whistleblowingProgram'){
      navigate(`/dedicated/corporate/corporate-integrity?activeTab=whistleblowingProgram&subActiveTab=${query.get('subActiveTab')||'whistleblowingProgramPageHeading'}`, {
        replace: true,
      });
    }
    if(query.get('activeTab')==='whistleblowingPolicy'){
      navigate(`/dedicated/corporate/corporate-integrity?activeTab=whistleblowingPolicy&subActiveTab=${query.get('subActiveTab')||'whistleblowingPolicyPageHeading'}`, {
        replace: true,
      });
    }
    if(query.get('activeTab')==='reportingConcern'){
      navigate(`/dedicated/corporate/corporate-integrity?activeTab=reportingConcern&subActiveTab=${query.get('subActiveTab')||'reportingConcernPageHeading'}`, {
        replace: true,
      });
    }
  }, [query.get('activeTab'), query.get('subActiveTab')]);


  const items = [
    {
      label: "Management Integrity Message",
      key: "managementIntegrityMessage",
      children: <ManagementIntegrityMessage/>
    },
    {
      label: "Anti-Bribery and Corruption Policy Statement",
      key: "antiBriberyCorruption",
      children: <AntiBriberyAndCorruptionPolicyStatement/>
    },
    {
      label: "Whistleblowing Program",
      key: "whistleblowingProgram",
      children:<WhistleBlowingProgram/>
    },
    {
      label: "Whistleblowing Policy",
      key: "whistleblowingPolicy",
      children: <WhistleBlowingPolicy/>
    },
    {
      label: "Reporting Of Concern Form",
      key: "reportingConcern",
      children: <ReportingConcern/>
    },
  ];

  return (
    <ContentWrapper
      title={"Corporate Integrity"}
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
